import { PaymentInformationDto } from "../models/dataTransferObjects/paymentInformation.dto";

export class PaymentInformationMapper {
    public static toDto(payment: any): PaymentInformationDto {
        return new PaymentInformationDto(payment.resultado.RazonSocial, payment.resultado.Rut, payment.resultado.Dv, payment.resultado.Correo, payment.resultado.ID_Banco, payment.resultado.TipoCuenta, payment.resultado.NumeroCuenta);
    }
}